import styled from 'styled-components';
import Text from '../Text';

const SuccessMessage = styled(Text)`
  margin: 5px auto;
  color: green;
`;

export default SuccessMessage;
